import React from 'react'
import { Modal } from 'react-bootstrap'
import { UserAuth } from '../../auth/Auth'; // Fixed path - go up two levels
import { isURL } from '../../../environment/Helper';
import { url } from '../../../environment/AxiosInstance';
import { Tooltip } from 'antd';

function ViewProjectTaskModal({ show, handleClose, task }) {
    const { MatchPermission, User } = UserAuth();
    
    // Only allow users with View Project permission to see task details
    if (!MatchPermission(['View Project', 'Project All', 'Doer Edit Project'])) {
        return null;
    }

    const formatDate = (date) => {
        if (!date) return "-";
        return new Date(date).toLocaleDateString("en-GB"); // dd-mm-yyyy
    };

    const getUserById = (id) => {
        if (!User) return null;
        return User.find(u => u.id === id) || null;
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-eye me-2"></i>
                    Task Details
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                {task && (
                    <div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <strong>Task Name:</strong>
                                <p>{task.task_name || task.taskname || 'N/A'}</p>
                            </div>
                            <div className="col-md-6">
                                <strong>Priority:</strong>
                                <span className={`badge ms-2 ${
                                    task.priority === 'High' ? 'bg-danger' :
                                    task.priority === 'Medium' ? 'bg-warning' : 'bg-success'
                                }`}>
                                    {task.priority || 'N/A'}
                                </span>
                            </div>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6">
                                <strong>Status:</strong>
                                <span className="badge bg-secondary ms-2">{task.status || 'N/A'}</span>
                            </div>
                            <div className="col-md-6">
                                <strong>Due Date:</strong>
                                <p>{formatDate(task.due_date)}</p>
                            </div>
                        </div>

                        {task.description && (
                            <div className="mb-3">
                                <strong>Description:</strong>
                                <p>{task.description}</p>
                            </div>
                        )}

                        {task.remarks && (
                            <div className="mb-3">
                                <strong>Remarks:</strong>
                                <p>{task.remarks}</p>
                            </div>
                        )}

                        {task.project && (
                            <div className="mb-3">
                                <strong>Project:</strong>
                                <p>{task.project.project_name}</p>
                            </div>
                        )}
                    </div>
                )}
            </Modal.Body>
            
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose}>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default ViewProjectTaskModal;
